module.exports = __webpack_public_path__ + "img/hdcg_bg.7f2ccf45.png";